import akLogo from "@/assets/ak-logo-badge.png";
import { Link } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";

export function Footer() {
  const { t } = useI18n();
  return (
    <footer id="footer" className="border-t border-border py-12 px-6 mt-12 scroll-mt-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-8 mb-10">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-3">
              <img src={akLogo} alt="AdKavi logo" className="w-10 h-10 rounded-full object-cover" />
              <span className="text-xl font-bold text-white">
                <span
                  style={{
                    background: "linear-gradient(135deg, #f97316, #dc2626)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  AdKavi
                </span>
                <span style={{ color: "#e8721a" }}>{" | "}</span>
                {t("footer.slogan")}
              </span>
            </div>
            <p className="text-sm text-muted-foreground">
              {t("footer.tagline")}
            </p>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-muted-foreground">
            <a href="/#features" className="hover:text-foreground transition">{t("footer.features")}</a>
            <a href="/#pricing" className="hover:text-foreground transition">{t("footer.pricing")}</a>
            <a href="/#how-it-works" className="hover:text-foreground transition">{t("footer.howItWorks")}</a>
            <Link to="/privacy" className="hover:text-foreground transition">{t("footer.privacy")}</Link>
            <Link to="/terms" className="hover:text-foreground transition">{t("footer.terms")}</Link>
            <Link to="/cookies" className="hover:text-foreground transition">{t("footer.cookies")}</Link>
            <Link to="/delete-data" className="hover:text-foreground transition">{t("footer.deleteData")}</Link>
            <Link to="/delete-data/status" search={{}} className="hover:text-foreground transition">{t("footer.deleteDataStatus")}</Link>
            <a href="mailto:support@adkavi.ai" className="hover:text-foreground transition">{t("footer.contact")}</a>
          </div>
        </div>
        <div className="border-t border-border pt-6 text-xs text-muted-foreground text-center">
          {t("footer.copyright")}
        </div>
      </div>
    </footer>
  );
}
